import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const ReceivedIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9422 4.35636C20.3232 3.92265 20.985 3.8787 21.4204 4.25819C21.8559 4.63769 21.9 5.29692 21.519 5.73063L9.29678 19.6437C9.10585 19.861 8.83302 19.9898 8.54323 19.9994C8.25344 20.009 7.97261 19.8986 7.76759 19.6944L2.5295 14.477C2.12038 14.0695 2.12038 13.4088 2.5295 13.0013C2.93862 12.5938 3.60193 12.5938 4.01105 13.0013L8.45734 17.43L19.9422 4.35636Z"
      fill={props.color}
    />
  </svg>
)
